import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import ImageBackground from '../common/imageBackground';
import ImageHeader from '../common/imageHeader';
import ImageButtonList from '../common/imageButtonList';
import NavigationBar from '../common/navigationBar';

class Service1240 extends Component {
  /**************
   * Properties *
   **************/
  header = {
    id: 'header',
    src: require('./images/1240_elements.png')
  };
  buttonList = {
    top: 140,
    left: 125
  };
  buttons = [
    {
      id: 'english',
      to: '/main_menu',
      highlight: require('./images/English_HL.png'),
      unhighlight: require('./images/English_UH.png'),
      alt: 'English'
    },
    {
      id: 'spanish',
      to: '/main_menu',
      highlight: require('./images/Spanish_HL.png'),
      unhighlight: require('./images/Spanish_UH.png'),
      alt: 'Spanish'
    }
  ];
  navigationBar = {
    mainMenu: true,
    back: true,
    backRoute: '/main_menu'
  };

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1240">
        <Switch>
          <Route
            path="/languages"
            render={routeProps => (
              <div>
                <ImageBackground id="background" />
                <ImageHeader {...this.header} />
                <ImageButtonList {...this.buttonList} imageButtons={this.buttons} />
                <NavigationBar {...this.navigationBar} />
              </div>
            )}
          />
        </Switch>
      </div>
    );
  }
}

export default withRouter(Service1240);
